import React from 'react';
import Heading from "components/common/Heading/Heading";
import Quote from "components/stories/Body/Quote";
import { breakpoints } from "themes/breakpoints.theme";
import { getImage } from './helper';

const renderParagraph = (content, quote, quotePosition, page) => {
    const createText = (data) => {
        return data.map((item) => {
          let element = item.text;
          // Link
          if (item.href) {
            element = React.createElement(
              "a",
              { href: item.href, target: "_blank", ...(item.nofollow) && {rel: "nofollow"} },
              element
            );
          }
          // Styles
          if (item.marks && item.marks.length > 0) {
            item.marks.forEach((mark) => {
              if (mark === "strong" || mark === "em") {
                element = React.createElement(mark, null, element);
              }
            });
          }
          return element;
        });
      };
      let result = [];
      /* This contentCount is needed to show quote in the right position
       ** ol/ul items are combined in a paragrahp sometimes. */
      let contentCount = 0;
      // eslint-disable-next-line
      content.map((paragraph, i) => {
        // Content
        let tag;
        switch (paragraph.style) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
            tag = (page === 'story') ? {name: 'Heading', level: 'h4'} : { name: "Heading", level: paragraph.style };
            break;
          case "ul":
          case "ol":
            tag = { name: paragraph.style };
            break;
          default:
            tag = { name: "p" };
            break;
        }
    
        // If the data element isn't an array, make it one
        if (!Array.isArray(paragraph.data)) {
          paragraph.data = [paragraph.data];
        }
    
        // In case of rendering ordered list (ol) or unordered list (ul)
        // Have to create ol/ul element with li childs so it could display correct order numbers
        // Have to check next comming elements are still in ol/ul tag
        if (tag.name === "ol" || tag.name === "ul") {
          const currentListType = tag.name;
          // Do not render if this list item is already rendered in previous element.. i.e..previous element is also list item
          if (content[i - 1] && content[i - 1].style === currentListType) {
            // eslint-disable-next-line
            return;
          }
          //Check next element
          let li = [React.createElement("li", null, createText(content[i].data))];
          let index = i + 1;
          while (content[index] && content[index].style === currentListType) {
            li.push(
              React.createElement("li", null, createText(content[index].data))
            );
            index++;
            contentCount++;
          }
          result.push(React.createElement(currentListType, { key: i }, li));
        } else {
          // Other Tags
          let currentElement = React.createElement(
            tag.name === "Heading" ? Heading : tag.name,
            tag.level ? { key: i, level: tag.level } : { key: i },
            createText(paragraph.data)
          );
          result.push(currentElement);
        }
    
        // Quote
        if (quote) {
          if (quotePosition && quotePosition === contentCount + 1) {
            result.push(<Quote content={quote} key={i} />);
          }
          if (!quotePosition && contentCount === content.length - 1) {
            result.push(<Quote content={quote} key={i} />);
          }
        }
    
        contentCount++;
      });
    
      return result;
}

function renderImage(image, size) {
  return image ? (
    <picture>
      <source
        media={`(min-width:${breakpoints.md})`}
        srcSet={getImage(image, size === "small" ? "medium" : "large")}
        type="image/webp"
      />
      <source
        media={`(min-width:${breakpoints.md})`}
        srcSet={getImage(image, size === "small" ? "medium" : "large", true)}
        type={getImageFormat(image)}
      />
      <source
        media={`(min-width:${breakpoints.sm})`}
        srcSet={getImage(image, "medium")}
        type="image/webp"
      />
      <source
        media={`(min-width:${breakpoints.sm})`}
        srcSet={getImage(image, "medium", true)}
        type={getImageFormat(image)}
      />
      <source
        media={`(min-width:${breakpoints.xs})`}
        srcSet={getImage(image, "small")}
        type="image/webp"
      />
      <source
        media={`(min-width:${breakpoints.xs})`}
        srcSet={getImage(image, "small", true)}
        type={getImageFormat(image)}
      />
      <img
        src={getImage(image, "org", true)}
        alt={image && image.alt ? image.alt : "no-alt"}
      />
    </picture>
  ) : null;
}

function getImageFormat(item) {
  let value = "";
  if (item && item.urls && item.urls.original && item.urls.original.original) {
    let dotIndex = item.urls.original.original.lastIndexOf(".");
    value = "image/" + item.urls.original.original.substring(dotIndex + 1);
  }
  return value;
}
 
export { renderParagraph, renderImage };
